import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Clients.css';

const formatSeconds = (seconds) => {
  const total = Math.max(0, parseInt(seconds || 0, 10));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientActivity, setClientActivity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activityLoading, setActivityLoading] = useState(false);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/users/clients/');
      setClients(response.data || []);
    } catch (error) {
      toast.error('Ошибка загрузки клиентов');
    } finally {
      setLoading(false);
    }
  };

  const fetchClientActivity = async (clientId) => {
    setActivityLoading(true);
    try {
      const response = await axios.get(`/api/users/clients/${clientId}/activity/`);
      setClientActivity(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки активности клиента');
    } finally {
      setActivityLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="clients-page">
      <div className="page-header">
        <h1>Клиенты</h1>
      </div>

      <div className="clients-layout">
        <div className="clients-table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Имя</th>
                <th>Источник</th>
                <th>Последний вход</th>
                <th>Прогрессов</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client) => (
                <tr key={client.id}>
                  <td>{client.email}</td>
                  <td>{`${client.first_name || ''} ${client.last_name || ''}`.trim() || '-'}</td>
                  <td>{client.auth_source || '-'}</td>
                  <td>{client.last_login ? new Date(client.last_login).toLocaleString('ru-RU') : '-'}</td>
                  <td>{client.progress_count || 0}</td>
                  <td>
                    <button
                      className="btn btn-outline btn-sm"
                      onClick={() => {
                        setSelectedClient(client);
                        fetchClientActivity(client.id);
                      }}
                    >
                      Открыть
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="client-activity-panel">
          {!selectedClient && <p>Выберите клиента для просмотра логов и прогресса</p>}
          {selectedClient && (
            <>
              <h3>{selectedClient.email}</h3>
              {activityLoading && <p>Загрузка активности...</p>}
              {!activityLoading && clientActivity && (
                <>
                  <h4>Просмотренные вебинары</h4>
                  <div className="activity-list">
                    {(clientActivity.progress || []).map((item) => (
                      <div key={item.id} className="activity-item">
                        <div className="activity-title">{item.webinar_title}</div>
                        <div className="activity-meta">
                          Остановился: {formatSeconds(item.last_position_seconds)} | Максимум: {formatSeconds(item.max_position_seconds)} | Заходов: {item.watched_count}
                        </div>
                      </div>
                    ))}
                    {(!clientActivity.progress || clientActivity.progress.length === 0) && <p>Нет данных просмотра</p>}
                  </div>

                  <h4>Логи клиента</h4>
                  <div className="activity-list">
                    {(clientActivity.logs || []).map((item) => (
                      <div key={item.id} className="activity-item">
                        <div className="activity-title">{item.action}</div>
                        <div className="activity-meta">
                          {new Date(item.created_at).toLocaleString('ru-RU')} | {item.ip_address}
                        </div>
                      </div>
                    ))}
                    {(!clientActivity.logs || clientActivity.logs.length === 0) && <p>Нет логов</p>}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Clients;
